<template>
  <b-row>
    <b-col cols="12">
      <faq-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FaqEditForm from './FaqEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    FaqEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
